module.exports = __webpack_public_path__ + "static/media/tempoReal.7b098a8b.png";